import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import clsx from 'clsx';

const ToolsMenu = ({
  upward,
  children,
  icon = 'ellipsis vertical',
  pointing = 'right',
  listItem = false,
  onChange,
}) => (
  <Dropdown
    className={clsx('aridhia-tools-menu', 'icon', { 'float-r': listItem })}
    floating
    icon={{
      name: icon,
      color: 'blue',
      link: true,
      className: 'primary',
    }}
    onOpen={onChange ? () => onChange(true) : undefined}
    onClose={onChange ? () => onChange(false) : undefined}
    pointing={pointing}
    upward={upward}
  >
    <Dropdown.Menu>
      {children}
    </Dropdown.Menu>
  </Dropdown>
);

export default ToolsMenu;
